'use client';

import { useIntl } from 'react-intl';

import {
	Checkbox,
	CheckboxAlign,
	CheckboxVerticalAlign,
	type AccessibleOnChange,
} from '@calm-web/design-system';

import messages from '@/components/authForm/MarketingOptIn/messages';
import { useIsCanadaDevice, useIsGDPRDevice, useIsUKGDPRDevice } from '@/hooks/user';

import { useSisu } from '../Provider';

export default function MarketingOptIn() {
	const { isMarketingOptInSelected, setIsMarketingOptInSelected } = useSisu();
	const isGDPRDevice = useIsGDPRDevice();
	const isUKGDPRDevice = useIsUKGDPRDevice();
	const isCanadaDevice = useIsCanadaDevice();
	const { formatMessage } = useIntl();

	const handleChange: AccessibleOnChange<HTMLInputElement> = event => {
		setIsMarketingOptInSelected(event.currentTarget.checked);
	};

	const displayCheckbox = isGDPRDevice || isUKGDPRDevice || isCanadaDevice;
	if (!displayCheckbox) {
		return null;
	}

	return (
		<Checkbox
			alignment={CheckboxAlign.Left}
			verticalAlignment={CheckboxVerticalAlign.Top}
			checked={isMarketingOptInSelected}
			name="marketing-opt-in"
			onChange={handleChange}
		>
			{formatMessage(messages.marketingOptIn)}
		</Checkbox>
	);
}
